var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditColorful({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.71875 12.125C3.71875 11.8661 3.92862 11.6562 4.1875 11.6562H10.125C10.3839 11.6562 10.5938 11.8661 10.5938 12.125C10.5938 12.3839 10.3839 12.5938 10.125 12.5938H4.1875C3.92862 12.5938 3.71875 12.3839 3.71875 12.125Z",
    fill: "#28303F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.57477 10.2425L3.72021 9.93606C4.02969 9.89185 4.31647 9.74845 4.53752 9.5274L8.68018 5.38475C8.68018 5.38475 7.65854 5.38475 6.6369 4.36311C5.61526 3.34146 5.61526 2.31982 5.61526 2.31982L1.4726 6.46248C1.25155 6.68353 1.10816 6.97032 1.06395 7.27979L0.757454 9.42524C0.689344 9.902 1.098 10.3107 1.57477 10.2425Z",
    fill: "#28303F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.7018 2.31982L8.68016 1.29818C8.11592 0.733941 7.20111 0.733941 6.63688 1.29818L5.61523 2.31982C5.61523 2.31982 5.61523 3.34146 6.63688 4.3631C7.65852 5.38474 8.68016 5.38474 8.68016 5.38474L9.7018 4.3631C10.266 3.79886 10.266 2.88405 9.7018 2.31982Z",
    fill: "#28303F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditColorful);
export default __webpack_public_path__ + "static/media/edit-colorful.0785cee6731ce8871fc88ef1d5851f8f.svg";
export { ForwardRef as ReactComponent };